// Tiny cross-section state: which tree is open, and the structured context
// (completed walk) the contact form should attach when the visitor asks for
// professional help. Module-scope refs — one SPA instance, no pinia needed.
import { ref } from 'vue'
import type { ContactContext } from '@/shared/api/types'

export const selectedTreeId = ref<string | null>(null)
export const contactContext = ref<ContactContext | undefined>(undefined)
export const contactContextLabel = ref<string | null>(null)

export function scrollTo(id: string) {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
}
